import { colors } from '../../Colors/colors'

export const documentTemplateTheme = {
   light: {
      documentTemplate: {
         documentTemplateHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500'],
         defaultBgColor: 'bg-gray-100',
         backIconColor: colors['gray-700']
      },
      common: {
         defaultBorderColor: 'border-gray-300',
         labelColor: 'text-gray-700',
         defaultBgColor: 'bg-gray-100',
         baseBgColor: 'bg-base-white',
         lineSeparatorBgColor: 'bg-gray-300',
         dtBlockTextColor: 'text-gray-600',
         optionsHoverBgColor: 'hover:bg-gray-50',
         optionsTextColor: 'text-gray-900',
         settingsIconColor: colors['gray-600'],
         settingsTextColor: 'text-gray-600',
         secondaryBgColor: 'bg-gray-50',
         transparentBgColor: '!bg-transparent',
         buttonDestructiveBgColor: '!hover:bg-error-50'
      },
      header: {
         titleColor: 'text-gray-900',
         bgColor: 'bg-base-white'
      },
      modals: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         errorTextColor: 'text-error-600'
      },
      documentsCard: {
         cardBgColor: 'bg-base-white',
         cardBorderColor: 'border-gray-300',
         defaultTextColor: 'text-gray-700',
         descriptionColor: 'text-gray-500',
         labelColor: 'text-gray-600',
         valueColor: 'text-gray-800'
      },
      actions: {
         textColor: 'text-gray-900',
         hoverBgColor: 'hover:bg-gray-50'
      },
      blockSettingsSidePane: {
         textColor: 'text-gray-900',
         defaultBorderColor: 'border-gray-300',
         baseBgColor: 'bg-base-white',
         captureSettings: {
            titleTextColor: 'text-gray-500',
            switchLabelTextColor: 'text-gray-700'
         },
         columnWidthSettings: {
            titleTextColor: 'text-gray-500',
            errorMessageBorderColor: 'border-error-300',
            errorMessageBgColor: 'bg-error-25',
            errorIconColor: colors['error-600'],
            errorMessageTextColor: 'text-error-700'
         },
         skipEmptyConditions: {
            titleTextColor: 'text-gray-500',
            switchLabelTextColor: 'text-gray-700'
         }
      }
   },
   dark: {}
}
